import { useQuery } from "react-query";
import { key_EsuraApiConnectionProperties } from "../utils/constants";
import { getEsuraApiConnectionProperties } from "../services/esuraApiConnectionProperties";

export const useEsuraApiConnectionProperties = () =>
  useQuery(
    [key_EsuraApiConnectionProperties,key_EsuraApiConnectionProperties],
    () =>  getEsuraApiConnectionProperties()
  );
